type ClerkUserLike = {
  primaryEmailAddress?: { emailAddress?: string | null } | null
  primaryPhoneNumber?: { phoneNumber?: string | null } | null
  fullName?: string | null
  firstName?: string | null
  lastName?: string | null
}

export function getClerkUserDisplayFields(user: ClerkUserLike | null | undefined): {
  email?: string
  name?: string
  phone?: string
} {
  if (!user) {
    return {}
  }

  const email = user.primaryEmailAddress?.emailAddress
  const phone = user.primaryPhoneNumber?.phoneNumber
  const name = user.fullName?.trim() || [user.firstName, user.lastName].filter(Boolean).join(' ').trim() || undefined

  return {
    ...(email ? { email } : {}),
    ...(name ? { name } : {}),
    ...(phone ? { phone } : {}),
  }
}
